import { useContext } from 'react';

import { ContentIdTrackingContext } from 'contexts/content-id-tracking/ContentIdTrackingContext';

export const useContentIdTracking = () => {
  const contentIdTrackingState = useContext(ContentIdTrackingContext);
  return contentIdTrackingState;
};
